/* LeatherShoe v2 interactions. No network calls, no cart calls (tracking untouched). */
(function () {
  function initHero(root) {
    if (!root || root.dataset.ls2Ready) return;
    root.dataset.ls2Ready = '1';
    var slides = root.querySelectorAll('.ls2-hero__slide');
    var copies = root.querySelectorAll('.ls2-hero__copy');
    var dots = root.querySelectorAll('.ls2-hero__dot');
    var n = slides.length, cur = 0, timer = null;
    var ms = parseInt(root.getAttribute('data-ms') || '7000', 10);
    root.style.setProperty('--ls2-hero-ms', ms + 'ms');
    if (n < 2) return;
    function go(i) {
      if (i === cur) return;
      var prev = cur; cur = (i + n) % n;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-on', k === cur);
        s.classList.toggle('is-prev', k === prev);
        s.setAttribute('aria-hidden', k === cur ? 'false' : 'true');
      });
      copies.forEach(function (c, k) { c.hidden = k !== cur; });
      dots.forEach(function (d, k) {
        d.setAttribute('aria-pressed', 'false');
        if (k === cur) { void d.offsetWidth; d.setAttribute('aria-pressed', 'true'); }
      });
      arm();
    }
    function arm() {
      clearTimeout(timer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setTimeout(function () { go(cur + 1); }, ms);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    var p = root.querySelector('[data-ls2-prev]'), nx = root.querySelector('[data-ls2-next]');
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else arm(); });
    arm();
  }

  function initSound(btn) {
    if (!btn || btn.dataset.ls2Ready) return;
    btn.dataset.ls2Ready = '1';
    var v = document.getElementById(btn.getAttribute('aria-controls'));
    if (!v) return;
    btn.addEventListener('click', function () {
      var on = v.muted;
      v.muted = !on;
      if (on) { try { v.currentTime = 0; } catch (e) {} var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? btn.getAttribute('data-label-on') : btn.getAttribute('data-label-off'));
      btn.classList.toggle('is-on', on);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ls2-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-ls2-sound]').forEach(initSound);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  function abHeight() {
    var a = document.querySelector('.shopify-section-group-header-group.announcement-bar-section, [id$="__announcement-bar"]');
    if (a) document.documentElement.style.setProperty('--ls2-ab', a.offsetHeight + 'px');
  }
  abHeight();
  window.addEventListener('resize', abHeight);
  window.addEventListener('load', abHeight);
})();
